/**
 * @func isObject
 * @param value - the input of the function
 * @return {boolean}
 * @desc Checks that the input is an object
 *```js
 * isObject('hi');
 * // returns false
 *
 * isObject({item: 1});
 * // returns true
 *```
 * @memberof module:TypeCheck
 * @instance
 */
function isObject(value) {
    if (value === null ||
        Array.isArray(value) ||
        typeof value !== 'object' ||
        value instanceof Function) {
        return false;
    }
    else {
        return true;
    }
}

export { isObject as default };
